import React, { Suspense, lazy, useEffect, useRef } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setAuthUser,
  setAuthentication,
  setGuestLogin,
} from './redux/features/Authentication/Customer/authUserSlice';
// import OrderSummeryPage from './Components/orderSummeryPage/orderSummery';
import { CheckElasticConnection } from '../src/redux/features/Home/allStatesSlice';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import { ProductQuickViewProvider } from './Components/ProductQuickView/ProductQuickViewContext';
import LandingPage from './Components/LandingPage';
import ScreenLoader from './Assets/screenLoader/Quickvee_loader_.gif';

const Home = lazy(() => import('./Components/Home/Main'));
const MainHome = lazy(() => import('./Components/MainHome/Main'));
const MainAuthentication = lazy(
  () => import('./Components/Authentication/Main/MainAuthentication'),
);
const MainOrder = lazy(() => import('./Components/Order/Main/MainOrder'));
const MainCart = lazy(() => import('./Components/Payment/Main/MainCart'));
const MainSingleStore = lazy(
  () => import('./Components/Store/SingleStore/MainSingleStore'),
);
const MainSingleStorOld = lazy(
  () => import('./Components/Store/SingleStore/MainSingleStoreOld'),
);
const NewOrderSummary = lazy(
  () => import('./Components/orderSummeryPage/NewOrderSummary'),
);
const MerchantCategory = lazy(
  () => import('./Components/MerchantCategory/Main'),
);
const MerchantHome = lazy(() => import('./Components/MerchantHome/Main'));
const WishList = lazy(() => import('./Components/WishList/Main'));
const AccountSetting = lazy(() => import('./Components/Setting/Main'));
const PageNotFound = lazy(
  () => import('./Components/ReusableComponent/PageNotFound'),
);
const NewArrivalPage = lazy(
  () => import('./Components/Home/NewArrival/NewArrivalPage'),
);
const StorePage = lazy(
  () => import('./Components/Home/StoresNearYou/StorePage'),
);
const PopularProductsPage = lazy(
  () => import('./Components/Home/PopularProducts/PopularProductsPage'),
);
const BestSellersPage = lazy(
  () => import('./Components/Home/BestSeller/BestSellerPage'),
);
const OffersPage = lazy(
  () => import('./Components/Home/OffersNearYou/OffersPage'),
);
const CustomCategoryPage = lazy(
  () => import('./Components/Home/CustomCategory/CustomCategoryPage'),
);
const BrandPage = lazy(() => import('./Components/Home/Brands/BrandPage'));
const LayoutShop = lazy(() => import('./Components/Shops/LayoutShop'));
const MainWishlist = lazy(() => import('./Components/WishList/Main'));
const LoyaltyPointSidebar = lazy(
  () => import('./Components/Setting/LoyaltyPoints/LoyaltyPointsSIdebar'),
);
const MainBuyItAgain = lazy(
  () => import('./Components/BuyItAgain/MainBuyItAgain'),
);
const BrandDetail = lazy(() => import('./Components/Home/Brands/BrandDetail'));
const AllBogoDeals = lazy(() => import('./Components/Bogo/AllBogoDeals'));
const AllMixMatchDeals = lazy(
  () => import('./Components/MixAndMatch/AllMixMatchDeals'),
);
const AboutUsMain = lazy(() => import('./Components/AboutUs/AboutUsMain'));
const MainBlog = lazy(() => import('./Components/Blog3/MainBlog'));
const BlogMain = lazy(() => import('./Components/Blog/Blog'));

const RouteFallback = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Loading"
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: 16,
      boxSizing: 'border-box',
      background: '#fff',
    }}
  >
    <img
      src={ScreenLoader}
      alt=""
      style={{
        display: 'block',
        width: 'clamp(72px, 22vw, 120px)',
        maxWidth: '100%',
        height: 'auto',
      }}
    />
  </div>
);
const Main = () => {
  const dispatch = useDispatch();
  const elasticCheckRequestedRef = useRef(false);
  const elasticConnectionStatus = useSelector(
    (state) => state?.allStatesData?.isElasticConnected,
  );
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const storeTypeParam = searchParams.get('store');
  const storeType =
    storeTypeParam === 'pickup'
      ? 'pickup'
      : storeTypeParam === 'delivery' || storeTypeParam === 'pickup'
        ? storeTypeParam
        : '';
  const hasLocationCookies = Boolean(
    Cookies.get('locationCity') && Cookies.get('userLocation'),
  );
  const localUserData = Cookies.get('userLoginData');
  const isGuest = Cookies.get('is_guest');
  const savedUserLocation = Cookies.get('userLocation');
  const savedCustomerAddresses = Cookies.get('customerAddresses');
  let hasSavedCustomerLocation = Boolean(savedUserLocation);
  if (!hasSavedCustomerLocation && savedCustomerAddresses) {
    try {
      const parsedAddresses = JSON.parse(savedCustomerAddresses);
      hasSavedCustomerLocation = Array.isArray(parsedAddresses) && parsedAddresses.length > 0;
    } catch {
      hasSavedCustomerLocation = false;
    }
  }
  useEffect(() => {
    if (
      location.pathname.startsWith('/payment-cart/') ||
      elasticConnectionStatus !== 'pending' ||
      elasticCheckRequestedRef.current
    ) {
      return;
    }

    elasticCheckRequestedRef.current = true;
    dispatch(CheckElasticConnection());
  }, [dispatch, elasticConnectionStatus, location.pathname]);

  useEffect(() => {
    if (localUserData) {
      dispatch(setAuthUser(JSON.parse(localUserData)));
      dispatch(setAuthentication(true));
      dispatch(setGuestLogin(isGuest === 'yes' ? 'yes' : false));
    } else {
      dispatch(setGuestLogin(true));
    }
  }, [isGuest, localUserData]);

  // removing orderStatus from sessionStorage if user is not on Checkout Form Page
  useEffect(() => {
    if (!location.pathname.startsWith('/payment-cart')) {
      if (sessionStorage.getItem('orderStatus')) {
        sessionStorage.removeItem('orderStatus');
      }
      sessionStorage.removeItem('orderStatusContext');
    }
  }, [location]);
  console.log('test in Main.js:');

  return (
    <ProductQuickViewProvider>
      <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route
          exact
          path="/"
          element={hasSavedCustomerLocation ? <Navigate to="/home" replace /> : <LandingPage />}
        />

        <Route exact path="/home" element={ <Home visible={'home'} storeType={storeType} />} />
        {/* <Route
          exact
          path="/:merchantName"
          element={<MerchantHome visible={'merchantHome'} />}
        /> */}
        <Route
          exact
          path="/:merchant_id/category/:categoryName/:categoryId"
          element={<MerchantCategory visible={'merchantCategory'} />}
        />
        <Route
          exact
          path="/category/:productCode"
          element={<MainHome visible={'category'} />}
        />
        <Route
          exact
          path="/category-product/:productCode"
          element={<MainHome visible={'categoryProduct'} />}
        />
        <Route
          exact
          path="/category-product-near/:productCode"
          element={<MainHome visible={'categoryProductNear'} />}
        />
        {/* <Route path="product/:productId" element={<ProductDetails />} /> */}
        {/* <Route
          exact
          path="/checkout"
          element={<Checkout visible={'checkout'} />}
        /> */}
        <Route
          exact
          path="/wishlist"
          element={<WishList visible={'wishlist'} />}
        />
        {/* <Route
          exact
          path="/wishlisthome"
          element={<WishListMain visible={'WishListMain'} />}/> */}
        <Route exact path="/wishlist/:merchant_id" element={<MainWishlist />} />

        {/* Account settings route */}
        <Route
          exact
          path="/setting/:settingType"
          element={<AccountSetting visible={'setting'} />}
        />

        <Route
          exact
          path="/forgot-password"
          element={<MainAuthentication visible={'forgot-password'} />}
        />
        <Route
          exact
          path="/customer-login"
          element={<MainAuthentication visible={'login'} />}
        />
        <Route
          exact
          path="/about-us"
          element={<MainHome visible={'AboutUs'} />}
        />
        <Route
          exact
          path="/privacy-policy"
          element={<MainHome visible={'policy'} />}
        />
        <Route
          exact
          path="/terms-condition"
          element={<MainHome visible={'termconditions'} />}
        />
        <Route
          exact
          path="/merchantlogin"
          element={<MainAuthentication visible={'merchantlogin'} />}
        />
        <Route
          exact
          path="/changePassword"
          element={<MainAuthentication visible={'changePassword'} />}
        />
        <Route
          exact
          path="/register"
          element={<MainAuthentication visible={'register'} />}
        />
        <Route
          exact
          path="/guest-checkout"
          element={<MainAuthentication visible={'guest-checkout'} />}
        />
        <Route exact path="/order" element={<MainOrder />} />
        <Route
          exact
          path="/order/order-history"
          element={<MainOrder visible={'orderhistory'} />}
        />
        {isGuest !== 'yes' && (
          <>
            <Route
              exact
              path="/order/profile"
              element={<MainOrder visible={'profile'} />}
            />
            <Route
              exact
              path="/order/storecreditzone"
              element={<MainOrder visible={'StoreCreditZone'} />}
            />
            <Route
              exact
              path="/order/loyaltypointzone"
              element={<MainOrder visible={'LoyaltyPointZone'} />}
            />
            <Route
              exact
              path="/order/address"
              element={<MainOrder visible={'Address'} />}
            />
            <Route
              exact
              path="/order/paymentmethodzone"
              element={<MainOrder visible={'PaymentMethodZone'} />}
            />
            <Route
              exact
              path="/order/giftcardzone"
              element={<MainOrder visible={'GoftCardZone'} />}
            />
            <Route
              exact
              path="/order/historyData"
              element={<MainOrder visible={'historyData'} />}
            />
            <Route
              exact
              path="/order/historyData/gift-card-history"
              element={<MainOrder visible={'gift-card'} />}
            />
            <Route
              exact
              path="/order/notifications"
              element={<MainOrder visible={'NotificationSettings'} />}
            />
          </>
        )}
        {/* <Route exact path="/order/profile"            render={(props) => <MainOrder {...props} visible={"profile"} />         }  /> */}
        {/* <Route exact path="/order/storecreditzone"  render={(props) => <MainOrder {...props} visible={"StoreCreditZone"}  />} />
        <Route exact path="/order/loyaltypointzone" render={(props) => <MainOrder {...props} visible={"LoyaltyPointZone"}  />} /> */}
        <Route exact path="/payment-cart/:productCode" element={<MainCart />} />
        <Route exact path="/store" element={<MainSingleStore />} />
        <Route
          exact
          path="/wishlist/:productCode"
          element={<MainSingleStore visible={'wishlist'} />}
        />
        {/* <Route
          exact
          path="/merchant/:productCode"
          element={<MainSingleStore visible={'merchant'} />}
        /> */}
        <Route
          exact
          path="/merchant/:productCode"
          element={<MerchantHome visible={'merchant'} />}
        />
        <Route
          exact
          path="old/merchant/:productCode"
          element={<MainSingleStorOld visible={'merchant'} />}
        />
        <Route
          exact
          path="/product/:productCode"
          element={<MainSingleStore visible={'product'} />}
        />
        <Route
          exact
          path="/popularproduct/:productCode"
          element={<MainHome visible={'popularProduct'} />}
        />
        {/* <Route
          exact
          path="/orderSummeryPage"
          element={<OrderSummeryPage visible={'orderSummery'} />}
        /> */}
        <Route
          exact
          // path="/newOrderSummeryPage"
          path="/orderSummeryPage"
          element={<NewOrderSummary visible={'orderSummery'} />}
        />
        <Route path="/new-arrivals" element={<NewArrivalPage />} />
        <Route path="/all-stores" element={<StorePage />} />
        <Route path="/popular-products" element={<PopularProductsPage />} />
        <Route path="/best-sellers" element={<BestSellersPage />} />
        <Route path="/offers" element={<OffersPage />} />
        <Route path="/all-custom-categories" element={<CustomCategoryPage />} />
        <Route path="/all-brands" element={<BrandPage />} />
        <Route path="/brand" element={<BrandDetail />} />

        <Route path="/Shop" element={<LayoutShop />} />
        <Route
          path="/loyalty-points/:merchant_id"
          element={<LoyaltyPointSidebar />}
        />

        <Route path="/buy-it-again" element={<MainBuyItAgain />} />
        <Route path="/buy-it-again/:merchant_id" element={<MainBuyItAgain />} />
        {/* <Route path="/bogo" element={<Bogo />} />  */}
        <Route path="/bogo" element={<AllBogoDeals />} />
        {/* <Route path="/bogo/:merchant_id" element={<BogoMerchant />} /> */}
        {/* <Route path="/bogo/:bogoId" element={<NewBogoMerchant />} /> */}
        {/* <Route path="/mixnmatch" element={<MixAndMatch />} /> */}
        <Route path="/mixnmatch" element={<AllMixMatchDeals />} />
        <Route path="/blog-about-us" element={<MainBlog />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/404" element={<PageNotFound />} />
        <Route path="/:blogLink" element={<AboutUsMain />} />
        <Route path="/blog2" element={<BlogMain />} />
      </Routes>
      </Suspense>
    </ProductQuickViewProvider>
  );
};

export default Main;
